var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5463 6.96015C8.89812 6.44346 8.24031 6.13048 7.60009 6.64639L7.21779 6.9582C6.93809 7.18454 6.41804 8.24212 4.40733 6.08638C2.39705 3.93338 3.59334 3.59815 3.87346 3.37376L4.25785 3.06156C4.89473 2.54448 4.65438 1.89355 4.19504 1.22349L3.91785 0.817629C3.45642 0.149132 2.95395 -0.289898 2.3154 0.226401L1.97037 0.507381C1.68816 0.698993 0.899284 1.32183 0.707928 2.50507C0.477631 3.92479 1.20411 5.55057 2.86853 7.3344C4.53086 9.11901 6.15843 10.0154 7.70016 9.9998C8.98145 9.98692 9.75525 9.34613 9.99727 9.11315L10.3435 8.83178C10.9804 8.31587 10.5847 7.7906 9.93613 7.27274L9.5463 6.96015Z",
    fill: "#00B087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhone);
export default __webpack_public_path__ + "static/media/user-phone.0f2d6d176aa945839f5fcd2956d7ccd8.svg";
export { ForwardRef as ReactComponent };